import type { Backend } from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import type { SwiftIdInvitationCollection } from './swift-id-invitation.types';

export function swiftIdInvitationBackend(): Backend<SwiftIdInvitationCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query) => ({
      endpoint: 'swift-id/invitation.php',
      isGaf: true,
      params: {
        id: getQueryParamValue(query, 'applicationId')[0],
      },
    }),
    push: (authUid, invitation) => ({
      endpoint: 'swift-id/invitation.php',
      isGaf: true,
      payload: {
        applicationId: invitation.applicationId,
        userId: invitation.userId,
      },
    }),
    set: undefined,
    update: (authUid, invitation, originalInvitation) => ({
      endpoint: `swift-id/invitation.php`,
      method: 'PUT',
      isGaf: true,
      payload: {
        id: originalInvitation.id,
        status: invitation.status as string,
      },
    }),
    remove: undefined,
  };
}
